/**
 * Constants for attribution tracking and storage.
 *
 * These constants define the behavior of UTM parameter capture,
 * sessionStorage keys, and timeout thresholds for attribution writes.
 */

/**
 * sessionStorage key for attribution data.
 *
 * Stores UTM parameters and referrer with 30-minute TTL.
 */
export const ATTRIBUTION_STORAGE_KEY = 'deaddrop_attribution';

/**
 * Attribution TTL in milliseconds (30 minutes).
 *
 * Attribution data expires after this duration from capturedAt timestamp.
 */
export const ATTRIBUTION_TTL_MS = 1800000;

/**
 * Maximum time to wait for attribution write to Clerk metadata (5 seconds).
 *
 * Attribution writes must complete or timeout before navigation proceeds.
 * Prevents race conditions between metadata write and backend read.
 */
export const ATTRIBUTION_CALLBACK_TIMEOUT_MS = 5000;
